import React from 'react'
import { Grid, Input, Form } from '@enterprise-ui/canvas-ui-react'
import '../../Cases/Custom.css'
import {
  VI18_REASON_CODE,
  VI19_REASON_CODE,
  VI19_SUB_REASON_CODES,
} from '../Services/ConstantData'
import { FormikValues } from 'formik'

interface CreateSubReasonCodeText2InputProps {
  subReasonCodeText2Label: string
  subReasonCodeText2Type: 'text' | 'number'
  formik: FormikValues
  state: any
  numericSubReasons: any
  textSubReasons: any
  subReasonCodeText2HelperText: string
}

const CreateSubReasonCodeText2Input: React.FC<
  CreateSubReasonCodeText2InputProps
> = ({
  subReasonCodeText2Label,
  subReasonCodeText2Type,
  formik,
  state,
  numericSubReasons,
  textSubReasons,
  subReasonCodeText2HelperText,
}) => {
  const handleInput = (e: any) => {
    const { reasonCode, subReasonCode } = formik.values || {}

    // VI18 or VI19 with PROMO_ID: digits and commas only
    if (
      reasonCode === VI18_REASON_CODE ||
      subReasonCode === VI19_SUB_REASON_CODES.PROMO_ID
    ) {
      e.target.value = e.target.value.replace(/[^0-9,]/g, '').replace(/\s/g, '')
    }
    // VI19 with DPCI_MIC: digits, dashes, and commas
    else if (subReasonCode === VI19_SUB_REASON_CODES.DPCI_MIC) {
      e.target.value = e.target.value
        .replace(/[^0-9\-,]/g, '')
        .replace(/\s/g, '')
    }
    // VI19 with ALLOWANCE: decimal with max 2 places
    else if (subReasonCode === VI19_SUB_REASON_CODES.ALLOWANCE) {
      let value = e.target.value.replace(/[^0-9.]/g, '')
      const parts = value.split('.')
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('')
      }
      if (parts[1] && parts[1].length > 2) {
        value = parts[0] + '.' + parts[1].substring(0, 2)
      }
      e.target.value = value
    }
    // VI19 with DATES: date format with commas
    else if (subReasonCode === VI19_SUB_REASON_CODES.DATES) {
      e.target.value = e.target.value
        .replace(/[^0-9/,]/g, '')
        .replace(/\s/g, '')
    }
    // Generic number type: positive numbers only
    else if (subReasonCodeText2Type === 'number') {
      e.target.value = Math.max(0, parseFloat(e.target.value))
        .toString()
        .slice(0, 11)
    }
  }
  return (
    <>
      <Grid.Container className="hc-pt-none hc-ml-expanded">
        <Grid.Item xs={10} md={10} className="hc-pt-md">
          <Form.Field
            id="subReasonCodeText2"
            label={subReasonCodeText2Label}
            type={subReasonCodeText2Type}
            onChange={(event: any) => {
              formik.setFieldValue('subReasonCodeText2', event.target.value)
            }}
            value={formik.values.subReasonCodeText2 ?? ''}
            onInput={handleInput}
            disabled={state.showDocuments}
            className="inputtype hc-ta-left"
            required={
              formik.values.reasonCode === VI18_REASON_CODE ||
              (formik.values.reasonCode === VI19_REASON_CODE &&
                formik.values.subReasonCode !== undefined &&
                (numericSubReasons.includes(formik.values.subReasonCode) ||
                  textSubReasons.includes(formik.values.subReasonCode)))
            }
          />
        </Grid.Item>
      </Grid.Container>
      <Grid.Container className="hc-pt-none hc-ml-expanded hc-pb-dense">
        <Grid.Item xs={10} md={10} className="hc-pb-md hc-pt-none">
          <Input.Info
            error={formik.errors.subReasonCodeText2 !== undefined}
            style={{ marginTop: '-13px' }}
          >
            {subReasonCodeText2HelperText}
          </Input.Info>
        </Grid.Item>
      </Grid.Container>
    </>
  )
}

export default CreateSubReasonCodeText2Input
